import $ from 'jquery'
import '@shopify/theme-addresses'
import nativeToast from 'native-toast'
import Cookies from 'js-cookie'
import 'jquery-zoom'
import 'slick-carousel';

import './scss/main.scss';

let theme = window.theme || {};
theme.cart = (function(){
    function addToCart(variant, quantity){
        $.ajax({
          url: '/cart/add.js', 
          type: 'POST',
          data: JSON.stringify({ quantity: quantity, id: variant }),
          dataType : "json",
          contentType: "application/json",
          success: function(){
              nativeToast({
                message: 'Added!',
                timeout: 5000,
                rounded: true,
                position: 'south',
                closeOnClick: true,
                type: 'success'
              })
          },
          error: function(e){
            let error = JSON.parse(e.responseText)
            console.log(error)
            if (error.status == 422){
              nativeToast({
                message: 'Out Of Stock!',
                timeout: 5000,
                rounded: true,
                position: 'south',
                closeOnClick: true,
                type: 'error'
              })
            }
          }
        })
      }
    return {
        addToCart: addToCart
    }
})($)
theme.comparisonTool = (function() {
    const metafields_namespace = "__comparison"
    const backend_url = 'https://pwa-comparison-app-jp927.ondigitalocean.app'
    let compareItems = []
    let metafieldId = null

    const setCookie = (name, value, options = {}) => {
        options = {
          path: '/',
          domain: '.crownandcaliber.com'
        };
      
        if (options.expires instanceof Date) {
          options.expires = options.expires.toUTCString();
        }
      
        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
      
        for (let optionKey in options) {
          updatedCookie += "; " + optionKey;
          let optionValue = options[optionKey];
          if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
          }
        }
      
        document.cookie = updatedCookie;
    }

    const deleteCookie = (name) => {
        setCookie(name, "", {
          'max-age': -1
        })
    }

    const getCookie = (name) => {
        let matches = document.cookie.match(new RegExp(
          "(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    const getUserId = () => {
        let userId = getCookie('__comparsionUserId')
        let oneWeekInSeconds = 604800
        if(userId === undefined || userId === ''){
            userId = '_' + Math.random().toString(36).substr(2, 9);

            setCookie('__comparsionUserId', userId, {
                "max-age": oneWeekInSeconds
            })
        }
        return userId
    }

    const getUserCompares = async () => {
        try {
            let request = await fetch(`${backend_url}/metafields/list?namespace=${metafields_namespace}&key=${getUserId()}`, {
                headers: {
                    "content-type": "application/json"
                }
            })
            let data = await request.json()
            if(data[0] && data[0].hasOwnProperty('value')){
                theme.comparisonTool.compareItems = JSON.parse(data[0].value).products
                theme.comparisonTool.metafieldId = data[0].id
                return theme.comparisonTool.compareItems
            }
        } catch(e){
            console.log(e)
        }
    }
    const buildComparePageHTML = async () => {
        if(window.location.pathname.includes('/pages/compare-products')){
            $('[data-user-key]').slideUp()

            let productsHeaderHtml = []
            let productsDetailsHtml = []
            let headerHtml = `<div class="cell large-auto bordered show-for-large">
                                <div class="compare-header">
                                    <h3>Compare Watches</h3>
                                    <a href="#" onclick="window.history.back()" class="btn btn-primary">Back</a>
                                </div>
                            </div>`
            let detailsHtml = `                
            <div class="cell large-auto show-for-large">
                <div class="prop-cell">
                    Condition
                </div>
                <div class="prop-cell">
                    Box
                </div>
                <div class="prop-cell">
                    Papers
                </div>
                <div class="prop-cell">
                    Manual
                </div>
                <div class="prop-cell">
                    Case Size
                </div>
                <div class="prop-cell">
                    Dial Color
                </div>
                <div class="prop-cell">
                    Approximate Age
                </div>
                <div class="prop-cell">
                    Max Srist Size
                </div>
                <div class="prop-cell">
                    Movement
                </div>
                <div class="prop-cell">
                    Case Materials
                </div>
                <div class="prop-cell">
                    Case Back
                </div>
                <div class="prop-cell">
                    Case Thickness
                </div>
                <div class="prop-cell">
                    Lug Width
                </div>
                <div class="prop-cell">
                    Bracelet
                </div>
                <div class="prop-cell">
                    Bezel
                </div>
                <div class="prop-cell">
                    Crystal
                </div>
                <div class="prop-cell">
                    Gender
                </div>
            </div>`

            $('.header-load').html('')
            $('.details-load').html('')

            for(let product of theme.comparisonTool.compareItems){
                let req = await fetch(`/products/${product}?view=compare_header`)
                let data = await req.text()
                productsHeaderHtml.push(`${data}`)
                // let req = await fetch(`/products/${product}?view=compare_header`)
                // let data = await req.text()
                
                // productsHeaderHtml += $(data).html()
                // $(data).insertAfter('.bordered.show-for-large')
            }
            for(let product of theme.comparisonTool.compareItems){
                let req = await fetch(`/products/${product}?view=compare`)
                let data = await req.text()
                productsDetailsHtml.push(`${data}`)
            }
            $('.header-load').html(headerHtml + productsHeaderHtml.join(''))
            $('.details-load').html(detailsHtml + productsDetailsHtml.join(''))
            
            $('.btn-primary[data-variant]').click(function(){
                theme.cart.addToCart($(this).data('variant'), 1)
            })
            $('.compare-items-table .compare-header .times').click(async function(){
                await theme.comparisonTool.removeFromCompare($(this).data('handle'))
            })

            $('[data-user-key]').slideDown()
            // $(productsHeaderHtml).insertAfter('.bordered.show-for-large')
            // $(productsDetailsHtml).append('.tracks')
        }
    }
    const removeFromCompare = async (productHandle) => {
        try {
            $(`.compare-items-line`).slideUp()
            theme.comparisonTool.compareItems = theme.comparisonTool.compareItems.filter(i => i !== productHandle)
            let request = await fetch(`${backend_url}/metafields/update/${theme.comparisonTool.metafieldId}`, {
                headers: {
                    "content-type": "application/json"
                },
                method: "POST",
                body: JSON.stringify({
                    namespace: metafields_namespace,
                    key: getUserId(),
                    value: JSON.stringify({
                        products: theme.comparisonTool.compareItems
                    }),
                    value_type: "json_string"
                })
            })
            let data = await request.json()
            compareItems = JSON.parse(data.value).products
            if(!window.location.href.includes('/pages/compare-products')){
                await theme.comparisonTool.updateComparsionLine()
            } else {
                await buildComparePageHTML()
            }
            return compareItems
        } catch(e){
            console.log(e)
        } 
    }
    const addToCompare = async (productHandle) => {
        if(!theme.comparisonTool.compareItems.includes(productHandle)){
            theme.comparisonTool.compareItems.push(productHandle)
            $(`.compare-items-line`).slideUp()
            if(theme.comparisonTool.metafieldId == null){
                try {
                    let request = await fetch(`${backend_url}/metafields/create`, {
                        headers: {
                            "content-type": "application/json"
                        },
                        method: "POST",
                        body: JSON.stringify({
                            namespace: metafields_namespace,
                            key: getUserId(),
                            value: JSON.stringify({
                                products: theme.comparisonTool.compareItems
                            }),
                            value_type: "json_string"
                        })
                    })
                    let data = await request.json()
                    theme.comparisonTool.compareItems = JSON.parse(data.value).products
                    theme.comparisonTool.metafieldId = data.metafieldId
                    await theme.comparisonTool.updateComparsionLine()
                    return theme.comparisonTool.compareItems
                } catch(e){
                    console.log(e)
                }
            } else {
                let request = await fetch(`${backend_url}/metafields/update/${theme.comparisonTool.metafieldId}`, {
                    headers: {
                        "content-type": "application/json"
                    },
                    method: "POST",
                    body: JSON.stringify({
                        namespace: metafields_namespace,
                        key: getUserId(),
                        value: JSON.stringify({
                            products: theme.comparisonTool.compareItems
                        }),
                        value_type: "json_string"
                    })
                })
                let data = await request.json()
                theme.comparisonTool.compareItems = JSON.parse(data.value).products
                await theme.comparisonTool.updateComparsionLine()
                return theme.comparisonTool.compareItems
            }
        } else {
            console.error('Item already in compare')
        }
    }
    const buildProductsHtml = async () => {
        let productsHtml = ``
        for(let i = 0; i <= 4; i++){
            if(theme.comparisonTool.compareItems[i] !== undefined){
                let req = await fetch(`/products/${theme.comparisonTool.compareItems[i]}.json`, {
                    headers: {
                        'content-type': 'application/json'
                    }
                })
                let data = await req.json()
                let product = data.product
                productsHtml += `<div class="compare-product">
                                        <a href="/products/${product.handle}">
                                            <img src="${product.image.src}" alt="${product.title}">
                                        </a>
                                        <span class="times" data-handle="${product.handle}">&times;</span>
                                </div>`
            } else {
                productsHtml += `<div class="compare-product"></div>`
            }
        }
        $('.compare-box').html(`<div class="compare-box">
                <div class="compare-items-line grid-x" style="display: none;">
                    <div class="compare-products">
                        ${productsHtml}
                    </div>
                    <a href="/pages/compare-products?view=compare-products" class="compare-button">Compare</a>
                </div>
        </div>`)

        if(theme.comparisonTool.compareItems.length > 0){
            $(`.compare-items-line`).slideDown()
        } else {
            $(`.compare-items-line`).slideUp()
        }
    }

    const updateComparsionLine = async () => {
        await buildProductsHtml()

        if(!theme.comparisonTool.compareItems.includes($('#comparsion-checkbox').data('product-handle'))){
            $('#comparsion-checkbox').prop('checked', false);
        }
        if(theme.comparisonTool.compareItems.length == 5 && !theme.comparisonTool.compareItems.includes($('#comparsion-checkbox').data('product-handle'))){
            $('#comparsion-checkbox').prop('disabled', true);
        } else {
            $('#comparsion-checkbox').prop('disabled', false);
        }
        $('.comparison-checkbox').each(function(){
            if(!theme.comparisonTool.compareItems.includes($(this).data('product-handle'))){
                $(this).prop('checked', false)
            }
            if(theme.comparisonTool.compareItems.length == 5 && !theme.comparisonTool.compareItems.includes($(this).data('product-handle'))){
                $(this).prop('disabled', true);
            } else {
                $(this).prop('disabled', false);
            }
        })
        $('.compare-items-line').removeClass('loading')
        $('.compare-items-line .compare-products .times').click(async function(){
            await theme.comparisonTool.removeFromCompare($(this).data('handle'))
        })
    }
    const initTopBarLine = async () => {
        if(!window.location.href.includes('/pages/compare-products')){
            await buildProductsHtml()

            if(theme.comparisonTool.compareItems.length > 0 && !$('body').hasClass('compare-products')){
                $(`.compare-items-line[data-user-key="${theme.comparisonTool.getUserId()}"]`).slideDown()
                if(theme.comparisonTool.compareItems.includes($('#comparsion-checkbox').data('product-handle'))){
                    $('#comparsion-checkbox').attr('checked', true)
                }
            }
            if(theme.comparisonTool.compareItems.length == 5 && $('#comparsion-checkbox:checked').length <= 0){
                $('#comparsion-checkbox').prop('disabled', true);
            } else {
                $('#comparsion-checkbox').prop('disabled', false);
            }
            $('.comparison-checkbox').each(function(){
                if(!theme.comparisonTool.compareItems.includes($(this).data('product-handle'))){
                    $(this).prop('checked', false)
                } else {
                    $(this).prop('checked', true)
                }
                if(theme.comparisonTool.compareItems.length == 5 && !theme.comparisonTool.compareItems.includes($(this).data('product-handle'))){
                    $(this).prop('disabled', true);
                } else {
                    $(this).prop('disabled', false);
                }
            })
            $('.compare-items-line .compare-products .times').click(async function(){
                await theme.comparisonTool.removeFromCompare($(this).data('handle'))
            })
        }
    }

    const initComparsionPage = async () => {
        // $('.compare-items-table').not(`[data-user-key="${theme.comparisonTool.getUserId()}"]`).remove()
        await buildComparePageHTML()

        $('.btn-primary[data-variant]').click(function(){
            theme.cart.addToCart($(this).data('variant'), 1)
        })
        $('.compare-items-table .compare-header .times').click(async function(){
            await theme.comparisonTool.removeFromCompare($(this).data('handle'))
        })
    }
    const init = async () => {
        await getUserCompares()

        // If pure JS will be required
        // document.body.querySelectorAll('[data-add-to-compare]').onClick = async function(e){
        //     if(!theme.comparisonTool.compareItems.includes(e.currentTarget.dataset['add-to-compare'])){
        //         await theme.comparisonTool.addToCompare(e.currentTarget.dataset['add-to-compare'])
        //     }
        // }
        $('.smallback').click(function(e){
            e.preventDefault()
            window.history.go(-1)
        })
        $('[data-add-to-compare]').click(async function(){
            if(!theme.comparisonTool.compareItems.includes($(this).data('add-to-compare'))){
                await theme.comparisonTool.addToCompare($(this).data('add-to-compare'))
            }
        })
        $('.compare-checkbox input').change(async function(){
            if($(this).is(':checked')){
                await theme.comparisonTool.addToCompare($(this).data('product-handle'))
            } else {
                await theme.comparisonTool.removeFromCompare($(this).data('product-handle'))
            }
        })
        initTopBarLine()
        if(!$('body').hasClass('copmare-products')){
            initComparsionPage()
        }
    }
    return {
        getUserId: getUserId,
        deleteCookie: deleteCookie,
        getUserCompares: getUserCompares,
        addToCompare: addToCompare,
        removeFromCompare: removeFromCompare,
        compareItems: compareItems,
        metafieldId: metafieldId,
        updateComparsionLine: updateComparsionLine,
        init: init
    }

})($)

theme.carousels = (function() {
    const recentlyViewed = async () => {
        var pHandle = $('[data-product-handle]').data('product-handle')
        if($('[data-product-handle]').length){
            if(Cookies.get('rv__recent_products') == undefined){
                Cookies.set('rv__recent_products', $('[data-product-handle]').data('product-handle'), {expires: 10, path: "/"});
            }
        }
        var currentProducts = [];
        if(Cookies.get('rv__recent_products') != undefined && $('.rv_slideshow').length){
            currentProducts = Cookies.get('rv__recent_products').split(",");
            
            if(currentProducts.indexOf(pHandle) == -1){
                // If we are at the limit move it to the front
                if(currentProducts.length >= 8){
                    currentProducts.unshift; // remove very last item
                }
                currentProducts.push(pHandle); // add this one
            }
            // prevent cookie override.
            if(currentProducts.length > 0){
                Cookies.set('rv__recent_products', currentProducts.join(","), {expires: 10, path: "/"});	
            }
            let pPointer = 0
            let html = ``
            for(let currentProduct of currentProducts.reverse()){
                if(!pPointer >= 8 || !currentProduct == ''){
                    let _json = await fetch(`/products/${currentProduct}.json`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        }
                    }).catch(e => console.log(e))
                    let _data = await _json.json()
                    let {product} = _data
                    let image_url = product.image.src
                    if(image_url.includes('.jpg')){
                        image_url = image_url.split('.jpg')[0] + "_600x" + '.jpg'
                    } else if(image_url.includes('.png')){
                        image_url = image_url.split('.png')[0] + "_600x" + '.png'
                    }
                    html += `<div class="rv_product">
                                <a href="/products/${product.handle}">
                                    <img src="${image_url}" alt="" />
                                </a>
                            </div>`
                    pPointer = pPointer + 1
                }
            }
            $('.rv_slideshow').html(html)
            $('.rv_slideshow').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                focusOnSelect: true,
                infinite: true,
                centerMode: false,
                draggable: false,
                // appendArrows: $('.slick-arrows'),
                prevArrow: `
                <div class="prev">
                <i class="fas fa-angle-left"</i>
                </div>
                `,
                nextArrow: `
                <div class="next">
                <i class="fas fa-angle-right"></i>
                </div>
                `,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
            });	
        }
    }

    const verticalZoomCarousel = () => {
        $('.vertical-thumbnail .slider').on('init', function() {

            if($(window).width() > 768){
              $('.vertical-thumbnail .slider--item').zoom({ magnify: 1, duration: 400 })
            }

            $('.vertical-thumbnail .slider-nav').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                asNavFor: '.vertical-thumbnail .slider',
                dots: false,
                arrows: true,
                focusOnSelect: true,
                infinite: true,
                centerMode: false,
                draggable: false,
                vertical: true,
                verticalSwiping: true,
                appendArrows: $('.slider-nav-arrows'),
                prevArrow: `
				<div class="prev">
				<i class="fas fa-angle-up"</i>
				</div>
				`,
                nextArrow: `
				<div class="next">
				<i class="fas fa-angle-down"></i>
				</div>
				`,
                responsive: [{
                    breakpoint: 640,
                    settings: "unslick"

                }]
            });
        })
        var $status = $('.pages');
        var $slickElement = $('.vertical-thumbnail .slider');

        $slickElement.on('init reInit afterChange', function(event, slick, currentSlide){
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            var i = (currentSlide ? currentSlide : 0) + 1;
            $status.text(i + ' of ' + slick.slideCount);
        });
        $('.vertical-thumbnail .slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            infinite: true,
            // appendArrows: $('.slider-arrows'),
            prevArrow: `
				<div class="prev">
				<i class="fas fa-angle-left"</i>
				</div>
				`,
            nextArrow: `
				<div class="next">
				<i class="fas fa-angle-right"></i>
				</div>
				`,
            responsive: [{
                breakpoint: 640,
                settings: {
                    dots: true,
                    swipe: true,
                    arrows: false,
                    infinite: true
                }
            }]
        });
    }

    const retailCarousel = (selector) => {
        $(selector).slick({
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 5,
            slidesToScroll: 5,
            arrows: true,
            draggable: true,
            prevArrow: `
			<div class="prev">
			<i class="fas fa-angle-left" aria-hidden="true"></i>
			</div>
			`,
            nextArrow: `
			<div class="next">
			<i class="fas fa-angle-right" aria-hidden="true"></i>
			</div>
			`
        })

    }

    const custsomerCarousel = () => {
        $(".custsomer-carousel").slick({
            autoplay: true,
            autoplaySpeed: 3000,
            draggable: true,
            prevArrow: `
			<div class="prev">
			<i class="fas fa-angle-left" aria-hidden="true"></i>
			</div>
			`,
            nextArrow: `
			<div class="next">
			<i class="fas fa-angle-right" aria-hidden="true"></i>
			</div>
			`
        })
    }

    const sliderCustsomerSays=()=>{
        $(".slider-customers-says").slick({
            autoplay: true,
            autoplaySpeed: 3000,
            draggable: true,
            prevArrow: `
			<div class="prev">
			<i class="fas fa-angle-left" aria-hidden="true"></i>
			</div>
			`,
            nextArrow: `
			<div class="next">
			<i class="fas fa-angle-right" aria-hidden="true"></i>
			</div>
			`
        })
    }

    const trendingmodelCarousel = () => {
        $(".trendingmodel-carousel").slick({
            autoplay: true,
            autoplaySpeed: 5000,
            draggable: true,
            slidesToShow: 5,
            slidesToScroll: 5,
            prevArrow: `
			<div class="prev">
			<i class="fas fa-angle-left" aria-hidden="true"></i>
			</div>
			`,
            nextArrow: `
			<div class="next">
			<i class="fas fa-angle-right" aria-hidden="true"></i>
			</div>
			`,
            responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 990,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        })

    }
    const reviewsSliderInit = () => {
        $(".reviews-carousel").slick({
            appendArrows: $(".carousel-arrows"),
            autoplay: true,
            autoplaySpeed: 3000,
            prevArrow: `
			<div class="prev">
				<svg aria-hidden="true" focusable="false" width="17" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z" class=""></path></svg>
			</div>
			`,
            nextArrow: `
			<div class="next">
				<svg aria-hidden="true" focusable="false" width="17" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" class=""></path></svg>
			</div>
			`
        });
        $(".pause-button").click(function(e) {
            e.preventDefault();
            if (
                $(this)
                .find("i.fa")
                .hasClass("fa-pause")
            ) {
                $(".reviews-carousel").slick("slickPause");
            } else if (
                $(this)
                .find("i.fa")
                .hasClass("fa-play")
            ) {
                $(".reviews-carousel").slick("slickPlay");
            }
            $(this)
                .find("i.fa")
                .toggleClass("fa-pause")
                .toggleClass("fa-play");
        });
    }
    const whySlider = () => {
        $(".why-carousel").slick({
            appendArrows: $(".why-carousel-arrows"),
            autoplay: true,
            autoplaySpeed: 3000,
            prevArrow: `
			<div class="prev">
				<svg aria-hidden="true" focusable="false" width="17" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z" class=""></path></svg>
			</div>
			`,
            nextArrow: `
			<div class="next">
				<svg aria-hidden="true" focusable="false" width="17" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" class=""></path></svg>
			</div>
			`
        });
        $(".why-pause-button-buy").click(function(e) {
            e.preventDefault();
            if (
                $(this)
                .find("i.fa")
                .hasClass("fa-pause")
            ) {
                $(".why-carousel").slick("slickPause");
            } else if (
                $(this)
                .find("i.fa")
                .hasClass("fa-play")
            ) {
                $(".why-carousel").slick("slickPlay");
            }
            $(this)
                .find("i.fa")
                .toggleClass("fa-pause")
                .toggleClass("fa-play");
        });
        $(".why-pause-button-sell").click(function(e) {
            e.preventDefault();
            if (
                $(this)
                .find("i.fa")
                .hasClass("fa-pause")
            ) {
                $(".why-carousel").slick("slickPause");
            } else if (
                $(this)
                .find("i.fa")
                .hasClass("fa-play")
            ) {
                $(".why-carousel").slick("slickPlay");
            }
            $(this)
                .find("i.fa")
                .toggleClass("fa-pause")
                .toggleClass("fa-play");
        });
    }
    const customizerEvents = () => {
        $(document).on('shopify:section:load', function() {
            $('.reviews-carousel.slick-initialized').slick('unslick')
            $('.retail-carousel.slick-initialized').slick('unslick')
            $('.why-carousel.slick-initialized').slick('unslick')
            $('.custsomer-carousel.slick-initialized').slick('unslick')
            $('.trendingmodel-carousel.slick-initialized').slick('unslick')
            $('.slider.slick-initialized').slick('unslick')
            $('.slider-customers-says.slick-initialized').slick('unslick')

            reviewsSliderInit()
            whySlider()
            custsomerCarousel()
            trendingmodelCarousel()
            verticalZoomCarousel()
            sliderCustsomerSays()
        })
    }
    const init = () => {
        reviewsSliderInit()
        whySlider()
        customizerEvents()
        custsomerCarousel()
        trendingmodelCarousel()
        verticalZoomCarousel()
        sliderCustsomerSays()
        recentlyViewed()
    };
    return {
        init,
        retailCarousel
    };
})($);

theme.header = (function() {
    const init = () => {
        $(".cd-search-trigger").on("click", function(event) {
            event.preventDefault();
            toggleSearch();
        });

        function toggleSearch(type) {
            if (type == "close") {
                //close serach
                $(".cd-search").removeClass("is-visible");
                $(".cd-search-trigger").removeClass("search-is-visible");
                $(".cd-overlay").removeClass("search-is-visible");
            } else {
                //toggle search visibility
                $(".cd-search").toggleClass("is-visible");
                $(".cd-search-trigger").toggleClass("search-is-visible");
                $(".cd-overlay").toggleClass("search-is-visible");
                $(".cd-search").find('input[type="search"]').focus();
                $(".cd-search").hasClass("is-visible") ?
                    $(".cd-overlay").addClass("is-visible") :
                    $(".cd-overlay").removeClass("is-visible");
            }
        }

        function morphDropdown(element) {
            this.element = element;
            this.mainNavigation = this.element.find(".main-nav");
            this.mainNavigationItems = this.mainNavigation.find(".has-dropdown");
            this.dropdownList = this.element.find(".dropdown-list");
            this.dropdownWrappers = this.dropdownList.find(".dropdown");
            this.dropdownItems = this.dropdownList.find(".content");
            this.dropdownBg = this.dropdownList.find(".bg-layer");
            this.mq = this.checkMq();
            this.bindEvents();
        }

        morphDropdown.prototype.checkMq = function() {
            //check screen size
            var self = this;
            return window
                .getComputedStyle(self.element.get(0), "::before")
                .getPropertyValue("content")
                .replace(/'/g, "")
                .replace(/"/g, "")
                .split(", ");
        };

        morphDropdown.prototype.bindEvents = function() {
            var self = this;
            //hover over an item in the main navigation
            this.mainNavigationItems
                .mouseenter(function(event) {
                    //hover over one of the nav items -> show dropdown
                    self.showDropdown($(this));
                })
                .mouseleave(function() {
                    setTimeout(function() {
                        //if not hovering over a nav item or a dropdown -> hide dropdown
                        if (
                            self.mainNavigation.find(".has-dropdown:hover").length == 0 &&
                            self.element.find(".dropdown-list:hover").length == 0
                        )
                            self.hideDropdown();
                    }, 50);
                });

            //hover over the dropdown
            this.dropdownList.mouseleave(function() {
                setTimeout(function() {
                    //if not hovering over a dropdown or a nav item -> hide dropdown
                    self.mainNavigation.find(".has-dropdown:hover").length == 0 &&
                        self.element.find(".dropdown-list:hover").length == 0 &&
                        self.hideDropdown();
                }, 50);
            });

            //click on an item in the main navigation -> open a dropdown on a touch device
            this.mainNavigationItems.on("touchstart", function(event) {
                var selectedDropdown = self.dropdownList.find(
                    "#" + $(this).data("content")
                );
                if (!self.element.hasClass("is-dropdown-visible") ||
                    !selectedDropdown.hasClass("active")
                ) {
                    event.preventDefault();
                    self.showDropdown($(this));
                }
            });

            //on small screens, open navigation clicking on the menu icon
            this.element.on("click", ".nav-trigger", function(event) {
                event.preventDefault();
                self.element.toggleClass("nav-open");
            });
        };

        morphDropdown.prototype.showDropdown = function(item) {
            this.mq = this.checkMq();
            if (this.mq == "desktop") {
                var self = this;
                var selectedDropdown = this.dropdownList.find(
                        "#" + item.data("content")
                    ),
                    selectedDropdownHeight = selectedDropdown.innerHeight(),
                    selectedDropdownWidth = selectedDropdown
                    .children(".content")
                    .innerWidth(),
                    selectedDropdownLeft =
                    item.offset().left +
                    item.innerWidth() / 2 -
                    selectedDropdownWidth / 2;

                //update dropdown position and size
                this.updateDropdown(
                    selectedDropdown,
                    parseInt(selectedDropdownHeight),
                    selectedDropdownWidth,
                    parseInt(selectedDropdownLeft)
                );
                //add active class to the proper dropdown item
                this.element.find(".active").removeClass("active");
                selectedDropdown
                    .addClass("active")
                    .removeClass("move-left move-right")
                    .prevAll()
                    .addClass("move-left")
                    .end()
                    .nextAll()
                    .addClass("move-right");
                item.addClass("active");
                //show the dropdown wrapper if not visible yet
                if (!this.element.hasClass("is-dropdown-visible")) {
                    setTimeout(function() {
                        self.element.addClass("is-dropdown-visible");
                    }, 10);
                }
            }
        };

        morphDropdown.prototype.updateDropdown = function(
            dropdownItem,
            height,
            width,
            left
        ) {
            this.dropdownList.css({
                "-moz-transform": "translateX(" + left + "px)",
                "-webkit-transform": "translateX(" + left + "px)",
                "-ms-transform": "translateX(" + left + "px)",
                "-o-transform": "translateX(" + left + "px)",
                transform: "translateX(" + left + "px)",
                width: width + "px",
                height: height + "px"
            });

            this.dropdownBg.css({
                "-moz-transform": "scaleX(" + width + ") scaleY(" + height + ")",
                "-webkit-transform": "scaleX(" + width + ") scaleY(" + height + ")",
                "-ms-transform": "scaleX(" + width + ") scaleY(" + height + ")",
                "-o-transform": "scaleX(" + width + ") scaleY(" + height + ")",
                transform: "scaleX(" + width + ") scaleY(" + height + ")"
            });
        };

        morphDropdown.prototype.hideDropdown = function() {
            this.mq = this.checkMq();
            if (this.mq == "desktop") {
                this.element
                    .removeClass("is-dropdown-visible")
                    .find(".active")
                    .removeClass("active")
                    .end()
                    .find(".move-left")
                    .removeClass("move-left")
                    .end()
                    .find(".move-right")
                    .removeClass("move-right");
            }
        };

        morphDropdown.prototype.resetDropdown = function() {
            this.mq = this.checkMq();
            if (this.mq == "mobile") {
                this.dropdownList.removeAttr("style");
            }
        };

        var morphDropdowns = [];
        if ($(".cd-morph-dropdown").length > 0) {
            $(".cd-morph-dropdown").each(function() {
                //create a morphDropdown object for each .cd-morph-dropdown
                morphDropdowns.push(new morphDropdown($(this)));
            });

            var resizing = false;

            //on resize, reset dropdown style property
            updateDropdownPosition();
            $(window).on("resize", function() {
                if (!resizing) {
                    resizing = true;
                    !window.requestAnimationFrame ?
                        setTimeout(updateDropdownPosition, 300) :
                        window.requestAnimationFrame(updateDropdownPosition);
                }
            });

            function updateDropdownPosition() {
                morphDropdowns.forEach(function(element) {
                    element.resetDropdown();
                });

                resizing = false;
            }
        }
    };
    return {
        init
    };
})($);

theme.utils = (function() {
    const isSkuAvailable = async (sku) => {
        try {
            const req = await fetch(`https://listings.crownandcaliber.com/v3/accounts/1/listings/${sku}/available`)
            return await req.json()
        } catch (e){
            console.log(e.message)
        }
    }
    const restoreBannerDataFromLocalStorage = () => {
        $('#pdp-trade').click(function (){
            const product = dataLayer.find(function(i) { return i.pageType === 'product' }).product
            localStorage.setItem('bannerData', JSON.stringify({
                brand: product.productBrand,
                modelNumber: product.productModelNumber,
                modelName: product.productModelName,
                sku: product.productSKU,
                image: document.querySelector("meta[property='og:image']").getAttribute("content"),
                url: window.location.href
            }));
            window.location = '/pages/trade-in-my-watch'
        })
        const bannerData = localStorage.getItem("bannerData");
        const encode = function(value) {
            return value.replace(/\s/g, '%20')
        }
        if (bannerData !== null && window.location.href.includes('/pages/trade-in-my-watch')) {
            $('.get-started-button').css('display', 'block')
            const parsedData = JSON.parse(bannerData);

            const brandElement = document.getElementById("ti-brand");
            brandElement.textContent = parsedData.brand;

            $('[data-product-url]').attr('href', parsedData.url)

            const modelElement = document.getElementById("ti-model");
            modelElement.textContent = parsedData.modelName;

            const image = document.getElementById("ti-img")
            image.src = parsedData.image.replace(/.jpg/g, '_x80.jpg');
            $('.tradein-header').slideDown()
            $('.get-started-button').click(function (){
                const iframeURL = `https://consumer.smartquote.crownandcaliber.com/#/?brand=${encode(parsedData.brand)}&model_name=${encode(parsedData.modelName)}&model_number=${encode(parsedData.modelNumber)}&sku=${encode(parsedData.sku)}`
                const iframeElement = document.createElement("iframe");
                iframeElement.setAttribute("src", iframeURL);
                iframeElement.setAttribute("width", '100%');
                new pym.Parent('iframe-parent', iframeURL, {});
            })
        } else {
            $('.popular-brands').show()
        }
    }
    const facetsSidebar = () => {
        $('.facets-mobile-button').click(function(){
            $('.collection-facets').addClass('active')
            $('body').addClass('overlay-active')
        })
        $('.collection-facets .mobile-header .arrow').click(function(){
            $('.collection-facets').removeClass('active')
            $('body').removeClass('overlay-active')
        })
    }
    const quoteActions = () => {
        // Create IE + others compatible event handler
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

        // Listen to message from child window
        eventer(messageEvent, function (e) {
            try{
              if(typeof e.data != "undefined" && e.data != null){
                var compareData = String(e.data);
                // if sent message is watch submitted redirect user to thank you page
              if (compareData == "watch_submitted" || compareData == "offer_submitted") {
                  window.location = window.theme.variables.thank_you_path;
              }
              if (compareData == "redirect_homepage") {
                  window.location = '/';
              }
              if (compareData == "et_scroll_to_top") {
                  $('html, body').scrollTop($('.rtip-iframe-container').position().top - $('.main-top').height());
              }
              if (compareData.match(/^webform_height_changed/)) {
                  var iframeHeight = compareData.split('#')[1];
                  $('.rtip-iframe-container').height(iframeHeight);
              }
            }
            }catch(e){
              console.log(e);
            }

        }, false);
      };

    const fetchRelatedProducts = async() => {
        if ($('.product-recommendations').length) {
            let product_id = $('.product-recommendations').data('product-id')
            let limit = $('.product-recommendations').data('limit')
            let response = await fetch(`/recommendations/products?section_id=product-recommendations&product_id=${product_id}`)
            let html = $(await response.text()).find('.product-recommendations').html()
            $('.product-recommendations').html(html)
            theme.carousels.retailCarousel('.trendingmodel-carousel')
            lazyLoad()
        }
    }
    $.fn.digits = function() {
        return this.each(function() {
            $(this).text($(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
        })
    }
    $(".estimated-retail").digits();
    const accountAddressInit = () => {
        if ($('#address_form_new').length) {
            window.Shopify.theme.addresses.AddressForm(document.getElementById('address_form_new'));
        }
        if ($('.edit_address_form').length) {
            document.querySelectorAll('.edit_address_form').forEach(function(el) {
                window.Shopify.theme.addresses.AddressForm(el);
            })
        }
    }
    const addAddressAccountPage = () => {
        $('.toggle-edit').click(function(e) {
            e.preventDefault()
            $(this).parent().parent().next().toggleClass('hide')
        })
        $('a[href="#toggle_address"]').click(function(e) {
            e.preventDefault()
            $('#add_address').toggleClass('hide')
            if ($('#add_address').hasClass('hide')) {
                $(this).text('ADD NEW ADDRESS')
            } else {
                $(this).text('CANCLE')
            }
        })
    }
    const sizingGuideInit = () => {
        let active_gender = $('.first-level-tab li.active').data('gender')
        let active_wirst = $(`[data-gender-selector="${active_gender}"] .second-level-tabs li.active`).data('wirst-size')
        let active_size = $(`[data-gender-selector="${active_gender}"] .third-level-tabs li[data-selector="${active_wirst}"]`).data('size')

        let update = () => {
            $('[data-gender-selector]').removeClass('active')
            $(`[data-gender-selector="${active_gender}"]`).addClass('active')
            $(`[data-gender-selector="${active_gender}"] [data-wirst-size]`).removeClass('active')
            $(`[data-gender-selector="${active_gender}"] [data-wirst-size="${active_wirst}"]`).addClass('active')
            $(`[data-gender-selector="${active_gender}"] .third-level-tabs li[data-selector="${active_wirst}"]`).hasClass('active') ? '' : $($(`[data-gender-selector="${active_gender}"] .third-level-tabs li[data-selector="${active_wirst}"]`)[0]).addClass('active')
            $(`.third-level-tabs li`).removeClass('shown')
            $(`[data-gender-selector="${active_gender}"] .third-level-tabs li[data-selector="${active_wirst}"]`).addClass('shown')
            $('.contents-block .content').removeClass('active')
            $(`.contents-block .content[data-selector="${active_gender}_${active_size}_${active_wirst}"]`).addClass('active')
        }
        let bindActiveToggler = () => {

            $('.first-level-tab li').click(function() {
                $(this).parent().children('li').removeClass('active')
                $(this).addClass('active')
                active_gender = $(this).data('gender')
                active_wirst = $(`[data-gender-selector="${active_gender}"] [data-wirst-size]:first-child`).data('wirst-size')
                active_size = $(`[data-gender-selector="${active_gender}"] .third-level-tabs li[data-selector="${active_wirst}"]`).data('size')
                update()
            })
            $('.second-level-tabs li').click(function() {
                $(`.third-level-tabs li`).removeClass('shown')
                $(this).parent().children('li').removeClass('active')
                $(this).addClass('active')
                active_wirst = $(this).data('wirst-size')
                $(this).parent().next().children(`li[data-selector="${active_wirst}"]`).addClass('shown')
                $(this).parent().next().children(`li[data-selector="${active_wirst}"].active`).removeClass('active')
                $($(this).parent().next().children(`li[data-selector="${active_wirst}"]`)[0]).addClass('active')
                active_size = $($(this).parent().next().children(`li[data-selector="${active_wirst}"]`)[0]).data('size')
                update()
            })
            $('.third-level-tabs li').click(function() {
                $(`.third-level-tabs li`).removeClass('shown')
                $(this).parent().children('li').removeClass('active')
                $(this).addClass('active')
                active_size = $(this).data('size')
                update()
            })
        }
        const checkboxGift = () => {
            $('#isgift').click(function (){
                $('.gift-message-box').toggleClass('active')
            })
            if($(window).width() <= 667){
                $('.gift-checkbox').prependTo('.mobile-gift-message')
            }
        }
        let init = () => {
            update()
            bindActiveToggler()
            quoteActions()
            facetsSidebar()
            checkboxGift()
        }
        init()
    }

    const lazyLoad = () => {
        var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

        if ("IntersectionObserver" in window) {
            let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        let lazyImage = entry.target;
                        lazyImage.src = lazyImage.dataset.src;
                        lazyImage.srcset = lazyImage.dataset.srcset;
                        lazyImageObserver.unobserve(lazyImage);
                        lazyImage.classList.remove("lazy");
                    }
                });
            });

            lazyImages.forEach(function(lazyImage) {
                lazyImageObserver.observe(lazyImage);
            });
        } else {
            // Possibly fall back to a more compatible method here
        }
    }
    const hubspotInit = () => {
        hbspt.forms.create({
            region: "na1",
            portalId: "3485016",
            formId: "53136bde-0f0e-470c-8563-116081228b22",
            target: "#soldout-signup-form"
        });

        hbspt.forms.create({
            portalId: "3485016",
            formId: "5c65d526-91b4-4719-835c-017803031487",
            target: ".hubspot-trade-in-form"
        });

        hbspt.forms.create({
            portalId: "3485016",
            formId: "650159c0-9599-450d-9939-c589f7854ee7",
            target: ".hubspot-buyer-form"
        });

        hbspt.forms.create({
            portalId: "3485016",
            formId: "b01358f9-49e1-4f17-9015-4809c4f311b1",
            target: ".hubspot-sell-a-watch"
        });

        hbspt.forms.create({
            portalId: "3485016",
            formId: "61c7ca5b-619d-44b2-80cd-64e5b0d9fedc",
            target: ".hubspot-support-dma"
        });

        hbspt.forms.create({
            portalId: "3485016",
            formId: "9963ac2b-033a-4bb6-9755-18b84f1ce593",
            target: ".hubspot-rma"
        });

        hbspt.forms.create({
            portalId: "3485016",
            formId: "be155c33-bf48-43f4-b2cc-87ff48025995",
            target: ".newsletter-contact-form",
            css: "",
            cssClass: "",
            locale: "en",
            onFormReady: function($form) {
                $form.find("input[type=email]").prop("placeholder", "Email Address");
            },
            translations: {
                en: {
                    required: "Email address is required",
                    invalidDate: "Please enter a real date",
                    submitText: "Subscribe"
                }
            }
        });
    };
    const pymInit = () => {
        if ($('#resp-sq-container').length) {
            let iframeEmbed = new pym.Parent('resp-sq-container', 'https://consumer.smartquote.crownandcaliber.com/#/', {});
            iframeEmbed.onMessage('openPopup', (msg) => {
                const modalData = JSON.parse(msg);
                const popupOffsetTop = modalData.offsetTop;
                const iframeOffsetTop = document.querySelector('iframe').offsetTop;
                const screenHeight = window.screen.height;
                const popupOffsetHeight = modalData.offsetHeight;
                window.scrollTo(0, iframeOffsetTop + popupOffsetTop + popupOffsetHeight - (screenHeight / 2));
            });
        }
        if($('#watch-iq').length){
            new pym.Parent('watch-iq', 'https://iq.smartquote.crownandcaliber.com/#/', {});
        }
        if($('#smart-quote').length){
            new pym.Parent('smart-quote', 'https://production.smartquote.crownandcaliber.com/#/', {});
        }
        if($('#iframe-embed-test').length){
            let iframeEmbedTest = new pym.Parent('iframe-embed-test', 'https://staging.consumer.smartquote.crownandcaliber.com/#/', {});
            iframeEmbedTest.onMessage('openPopup', (msg) => {
                const modalData = JSON.parse(msg);
                const popupOffsetTop = modalData.offsetTop;
                const iframeOffsetTop = document.querySelector('iframe').offsetTop;
                const screenHeight = window.screen.height;
                const popupOffsetHeight = modalData.offsetHeight;
                window.scrollTo(0, iframeOffsetTop + popupOffsetTop + popupOffsetHeight - (screenHeight / 2))
            })
        }
    }
    const anchorScrolling = () => {
        let $anchorTrigger = $(".back-top");
        $(window).scroll(function() {
            if ($(window).scrollTop() > 500) {
                $anchorTrigger.fadeTo(1, 0.8);
            } else {
                $anchorTrigger.fadeTo(1, 0);
            }
        });
        $('a[href*="#"]')
            // Remove links that don't actually link to anything
            .not('[href="#"]')
            .not('[href="#0"]')
            .click(function(event) {
                // On-page links
                if (
                    location.pathname.replace(/^\//, "") ==
                    this.pathname.replace(/^\//, "") &&
                    location.hostname == this.hostname
                ) {
                    // Figure out element to scroll to
                    let target = $(this.hash);
                    target = target.length ?
                        target :
                        $("[name=" + this.hash.slice(1) + "]");
                    // Does a scroll target exist?
                    if (target.length) {
                        event.preventDefault();
                        $("html, body").scrollTop(target.offset().top - 100);
                    }
                }
            });
    };
    /*
    const cardRotate = () => {
        $(".btn-leadership-rotate").click(function(e) {
            e.preventDefault()
            $(this).parent().find('.leadership-card').toggleClass('rotate-leadership-card')
        });
    }
    */
    const initOpacity = () => {
        const opacityScroll = element => {
            $(window).scroll(function() {
                $(element).css("opacity", 1 - $(window).scrollTop() / 650);
            })
        }


        opacityScroll('.our-mission .our-mission--top')
        opacityScroll('.who-we-are .top-section')
        opacityScroll('.retail-trade-in .top-section')
        opacityScroll('.page-scholarship .top-section')
        opacityScroll('.page-careers .top-section')
        opacityScroll('.why-buy-from-us .top-section')
        opacityScroll('.why-sell-with-us .top-section')
    }

    const pressAccordeon = () => {
        $(".press-page .press-page-title").click(function(e) {
            e.preventDefault()
            $(this).next('.press-block').toggleClass('active')
        });
    };

    const showPopupProduct = () => {
        $(".icon-popup").hover(function() {
            $(this).next(".product-popup").addClass("show")
        });

    }

    const hidePopupProduct = () => {
        $(".product-popup_close").click(function(e) {
            e.preventDefault()
            $(this).parent().removeClass("show")
        })
    }

    const mobileSpecificationAccordeon = () => {
        $(".specification-accordeon-text h2").click(function(e) {
            e.preventDefault()
            console.log('click h2');

            $(this).next("p").toggleClass("show")
        });
    }

    const productAccessoriesAccordeon=() => {
        $(".accordion-container .discription-accordion h2").click(function (e) {
            e.preventDefault()

            $(this).toggleClass("h2-show")
            $(this).next(".discription-accordion-content").toggleClass("show-content")
        })
    }

    const productPageButtonSwitch = async () => {
        const button = $('#pending-sale-btn')
        if($('#pending-sale-btn').length > 0 && !$('#add-to-cart-btn').is('[disabled]')){
            if(await theme.utils.isSkuAvailable(button.data('sku')) === false) {
                button.show()
                $('#add-to-cart-btn').hide()
                $('#pdp-trade').hide()
            }
        }
    }
    const init = () => {
        anchorScrolling();
        hubspotInit();
        lazyLoad();
        // cardRotate();
        initOpacity();
        pressAccordeon();
        sizingGuideInit();
        addAddressAccountPage();
        accountAddressInit();
        showPopupProduct();
        hidePopupProduct();
        mobileSpecificationAccordeon();
        fetchRelatedProducts();
        pymInit();
        productAccessoriesAccordeon();
        restoreBannerDataFromLocalStorage();
        productPageButtonSwitch();
    };

    return {
        init,
        isSkuAvailable
    };
})($);

theme.footer = (function() {
    const mobileContentSliding = () => {
        $("footer .custom_footer_menu .column-heading").click(function(e) {
            e.preventDefault()
            $(this).next('.links-list').toggleClass('active')
        });
    };

    const init = () => {
        mobileContentSliding();
    };
    return {
        init
    };
})($);

theme.init = function() {
    theme.utils.init();
    theme.carousels.init();
    theme.header.init();
    theme.footer.init();
    theme.comparisonTool.init()
    // $(document).foundation();

};

theme.init($);